import React from 'react';
import { UserPermissionModel } from './types';

const DEFAULT_VALUE: {
  customerIds: number[];
  setCustomerIds: (language: number[]) => void;
  locationIds: number[];
  setLocationIds: (language: number[]) => void;
  userPermissions: UserPermissionModel;
  setUserPermissions: (permissions: UserPermissionModel) => void;
} = {
  customerIds: [],
  setCustomerIds(value) {
    this.customerIds = value;
  },
  locationIds: [],
  setLocationIds(value) {
    this.locationIds = value;
  },
  userPermissions: { loaded: false } as UserPermissionModel,
  setUserPermissions(permissions) {
    this.userPermissions = permissions;
  },
};

export const AppCustomerContext = React.createContext(DEFAULT_VALUE);
